import {createSlice, createAsyncThunk} from '@reduxjs/toolkit'
import {
  onCreateGraduatedDocument,
  onDeleteGraduatedDocument,
  onGetGraduatedDocument,
  onUpdateGraduatedDocument,
  onGetGraduatedDocumentByGraduatedId,
} from '../../../app/modules/graduation-system/components/graduates/component/graduated-document/core/_requests'
import {
  onGetGraduates,
  onGetCardStatuses,
  onGetDeliveryTypes,
} from '../../../app/services/dataForComboBox/dataForComboBoxService'
interface GraduatedDocumentState {
  graduatedDocuments: any
  graduatedDocument: any
  graduates: any
  cardStatuses: any
  deliveryTypes: any
  isLoading: boolean
}
const initialState = {
  graduatedDocuments: [],
  graduatedDocument: null,
  graduates: [],
  cardStatuses: [],
  deliveryTypes: [],
  isLoading: true,
} as GraduatedDocumentState

export const fetchGraduates = createAsyncThunk('graduatedDocument/fetchGraduates', async () => {
  const data: any = await onGetGraduates()
  return data.data.result
})

export const fetchCardStatuses = createAsyncThunk(
  'graduatedDocument/fetchCardStatuses',
  async () => {
    const data: any = await onGetCardStatuses()
    return data.data.result
  }
)

export const fetchDeliveryTypes = createAsyncThunk(
  'graduatedDocument/fetchDeliveryTypes',
  async () => {
    const data: any = await onGetDeliveryTypes()
    return data.data.result
  }
)

export const fetchGraduatedDocumentsByGraduatedId = createAsyncThunk(
  'graduatedDocument/fetchGraduatedDocumentsByGraduatedId',
  async (param: any) => {
    const data: any = await onGetGraduatedDocumentByGraduatedId(param)
    return data.data.result
  }
)

export const fetchGraduatedDocument = createAsyncThunk(
  'graduatedDocument/fetchGraduatedDocument',
  async (param: any) => {
    const data: any = await onGetGraduatedDocument(param)
    return data.data.result
  }
)

export const updateGraduatedDocument = createAsyncThunk(
  'graduatedDocument/updateGraduatedDocument',
  async (param: any) => {
    const data: any = await onUpdateGraduatedDocument(param)
    return data.data
  }
)

export const createGraduatedDocument = createAsyncThunk(
  'graduatedDocument/createGraduatedDocument',
  async (param: any) => {
    const data: any = await onCreateGraduatedDocument(param)
    return data.data
  }
)

export const deleteGraduatedDocument = createAsyncThunk(
  'graduatedDocument/deleteGraduatedDocument',
  async (param: any) => {
    const data: any = await onDeleteGraduatedDocument(param)
    return data.data
  }
)

const graduatedDocumentSlice = createSlice({
  name: 'graduatedDocument',
  initialState,
  reducers: {
    clearGraduatedDocuments: (state) => {
      state.graduatedDocuments = []
    },
    clearGraduatedDocument: (state) => {
      state.graduatedDocument = null
    },
    activateLoading: (state) => {
      state.isLoading = true
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchGraduatedDocumentsByGraduatedId.pending, (state: any) => {
      state.isLoading = true
    })
    builder.addCase(fetchGraduatedDocumentsByGraduatedId.fulfilled, (state: any, action) => {
      state.graduatedDocuments = action.payload
      state.isLoading = false
    })
    builder.addCase(fetchGraduatedDocumentsByGraduatedId.rejected, (state: any) => {
      state.isLoading = false
    })
    builder.addCase(fetchGraduatedDocument.fulfilled, (state: any, action) => {
      state.graduatedDocument = action.payload
    })
    builder.addCase(fetchGraduates.fulfilled, (state: any, action) => {
      state.graduates = action.payload.items
    })
    builder.addCase(fetchCardStatuses.fulfilled, (state: any, action) => {
      state.cardStatuses = action.payload.items
    })
    builder.addCase(fetchDeliveryTypes.fulfilled, (state: any, action) => {
      state.deliveryTypes = action.payload.items
    })
  },
})

export const {clearGraduatedDocuments, clearGraduatedDocument, activateLoading} =
  graduatedDocumentSlice.actions

export default graduatedDocumentSlice.reducer
